"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderListingResponse = exports.OrderAssignContainerInput = exports.OrderCreateTransport = exports.OrderCreateInput = exports.OrderTransport = exports.BillingStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const common_2 = require("../common");
const nullable_1 = require("../common/nullable");
const weight_1 = require("../common/weight");
const customer_1 = require("../customer");
const equipment_1 = require("../equipment");
const invoice_1 = require("../invoice");
const receivable_transport_1 = require("../invoice/receivable-transport");
const pricing_1 = require("../pricing");
const internal_note_1 = require("./internal-note");
const order_action_transport_1 = require("./order-action-transport");
const order_status_1 = require("./order-status");
const order_switch_transport_1 = require("./order-switch-transport");
exports.BillingStatus = typebox_1.Type.Union([
    typebox_1.Type.Literal('OPEN'),
    typebox_1.Type.Literal('BILLED'),
    typebox_1.Type.Literal('INVOICED'),
    typebox_1.Type.Literal('PAYMENT_RECIEVED'),
    typebox_1.Type.Literal('CLOSED'),
]);
exports.OrderTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    orderNumber: typebox_1.Type.Optional(typebox_1.Type.Number()),
    status: order_status_1.OrderStatus,
    billingStatus: typebox_1.Type.Optional(exports.BillingStatus),
    allowedNextStatuses: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    serviceLocationID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceLocation: common_2.ServiceLocationTransport,
    /**
     * @deprecated - Removed in favor of Containers and ContainerAssignmentId
     */
    dumpsterID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    /**
     * @deprecated - Removed in favor of Containers and ContainerAssignmentId
     */
    dumpsterName: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * @deprecated - Removed in favor of Containers and ContainerAssignmentId
     */
    dumpsterSnapshot: typebox_1.Type.Optional(typebox_1.Type.Unknown()),
    /**
     * @deprecated - Removed in favor of Containers and ContainerAssignmentId
     */
    dumpster: typebox_1.Type.Optional(equipment_1.DumpsterTransport),
    /**
     * @deprecated - soft joins have been removed
     */
    receivables: typebox_1.Type.Optional(typebox_1.Type.Array(receivable_transport_1.WaysteReceivableTransport)),
    /**
     * @deprecated - soft joins have been removed
     */
    payables: typebox_1.Type.Optional(typebox_1.Type.Array(invoice_1.PayableTransport)),
    containerTypeID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    containerAssignmentID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({
        format: 'uuid',
        description: 'The id of the assignment in the equipment (dumpster) service which holds the container id. Never directly set by the user.',
    }))),
    containerName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({
        description: 'The name of the container assigned to the order. Automatically set by the system based on the containerAssignmentID. Never directly set by the user.',
    }))),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    customerSnapshot: typebox_1.Type.Optional(typebox_1.Type.Unknown()),
    customer: typebox_1.Type.Optional(customer_1.BaseCustomer),
    requestedDeliveryDate: typebox_1.Type.String(),
    expectedDeliveryDate: typebox_1.Type.String(),
    requestedPickupDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    expectedPickupDate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    requestedSize: typebox_1.Type.Optional(typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    })),
    expectedSize: typebox_1.Type.Optional(typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    })),
    delivery: typebox_1.Type.Optional(order_action_transport_1.OrderActionTransport),
    deliveryNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickup: typebox_1.Type.Optional(order_action_transport_1.OrderActionTransport),
    pickupNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    disposalSiteID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    disposalSiteSnapshot: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Unknown())),
    dumpTicketNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    dumpTicketImage: typebox_1.Type.Optional((0, nullable_1.Nullable)(common_1.S3ItemReference)),
    otherImages: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    switches: typebox_1.Type.Optional(typebox_1.Type.Array(order_switch_transport_1.OrderSwitchTransport)),
    material: typebox_1.Type.String(),
    internalNotes: typebox_1.Type.Optional(typebox_1.Type.Array(internal_note_1.InternalNote)),
    weightLimit: weight_1.Weight,
    actualWeightDumped: typebox_1.Type.Optional((0, nullable_1.Nullable)(weight_1.Weight)),
    originalRentalPeriod: common_1.Duration,
    adjustedRentalPeriod: common_1.Duration,
    rentalExtensionDate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    isSourgumOrder: typebox_1.Type.Boolean(),
    rentExtensionFee: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    overageFee: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    priceType: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    paymentMethod: typebox_1.Type.Optional((0, nullable_1.Nullable)(common_1.PaymentMethod)),
    paymentTerm: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    contactsToNotify: typebox_1.Type.Optional(typebox_1.Type.Array(customer_1.BaseCustomerContact)),
    customerPricingSnapshot: typebox_1.Type.Optional((0, nullable_1.Nullable)(pricing_1.RollOffPricingSnapshot)),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.OrderCreateInput = typebox_1.Type.Pick(exports.OrderTransport, [
    'poNumber',
    'status',
    'billingStatus',
    'serviceLocationID',
    'serviceLocation',
    'customerID',
    'deliveryNotes',
    'requestedDeliveryDate',
    'expectedDeliveryDate',
    'requestedPickupDate',
    'expectedPickupDate',
    'requestedSize',
    'expectedSize',
    'material',
    'internalNotes',
    'weightLimit',
    'originalRentalPeriod',
    'adjustedRentalPeriod',
    'disposalSiteID',
    'pickupNotes',
    'priceType',
    'paymentMethod',
    'paymentTerm',
    'rentExtensionFee',
    'overageFee',
    'customerName',
    'customerCompanyName',
    'customerAccountNumber',
    'containerTypeID',
    'contactsToNotify',
    'customerPricingSnapshot',
]);
exports.OrderCreateTransport = typebox_1.Type.Object({
    haulerName: typebox_1.Type.String(),
    orderData: exports.OrderCreateInput,
    receivableData: typebox_1.Type.Optional(receivable_transport_1.WaysteCreateReceivableTransport),
    suppressOrderConfirmation: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    contactsToNotify: typebox_1.Type.Optional(typebox_1.Type.Array(customer_1.BaseCustomerContact)),
    paymentData: typebox_1.Type.Optional(typebox_1.Type.Intersect([
        typebox_1.Type.Object({
            paymentType: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('internal'), typebox_1.Type.Literal('stripe')])),
        }),
        typebox_1.Type.Union([
            typebox_1.Type.Object({
                paymentType: typebox_1.Type.Literal('internal'),
                paymentInput: typebox_1.Type.Omit(invoice_1.PaymentCreateTransport, ['amount']),
            }),
            typebox_1.Type.Object({
                paymentType: typebox_1.Type.Literal('stripe'),
                paymentInput: typebox_1.Type.Object({
                    stripeCustomerID: typebox_1.Type.Optional(typebox_1.Type.String()),
                    stripeSourceID: typebox_1.Type.Optional(typebox_1.Type.String()),
                }),
            }),
        ]),
    ])),
});
exports.OrderAssignContainerInput = typebox_1.Type.Object({
    containerID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.OrderListingResponse = typebox_1.Type.Object({
    count: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    results: typebox_1.Type.Array(exports.OrderTransport),
    thisBatch: typebox_1.Type.Number(),
});
//# sourceMappingURL=order-transport.js.map